<template>
  <div :class="$style['number-direction']">
    <p :class="$style['direction-title']">双数研究院</p>
    <p :class="$style['direction-title']">三大重点工作方向</p>
    <img src="@/assets/img/number/m_direction-title.png" :class="$style['direction-img']"/>
    <div :class="$style['direction-list']">
      <div :class="$style['direction-content']" :key="index" v-for="(item, index) in directionList">
        <div :class="$style['content-header']" :style="{background: item.titleBg}">{{ item.title }}</div>
        <div :class="$style['content-desc']" v-html="item.intro"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { directionList } from './data'

export default {
  name: '',
  components: {
  },
  props: {
  },
  data () {
    return {
      directionList
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {}
}
</script>
<style lang='scss' module>
.number-direction {
  box-sizing: border-box;
  width: 100%;
  padding: 134px 0 50px;
  background: #F9F9F9;
  text-align: center;

  & .direction-title {
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #404040;
  }
  & .direction-img {
    width: 156px; height: 156px;
    margin: 24px auto 19px;

  }
  & .direction-content {
    width: 335px;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 2px 20px 0px rgba(151,151,194,0.13);
    border-radius: 10px;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    & .content-header {
      width: 335px; height: 50px;
      line-height: 50px;
      border-radius: 10px 10px 0px 0px;
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;

    }

    & .content-desc {
      box-sizing: border-box;
      padding: 20px 16px;
      text-align: left;
      font-size: 14px;
      font-weight: 300;
      color: #404040;
      line-height: 28px;

      & strong {
        font-weight: 500;
      }
    }
  }
}
</style>
